import { gatewaySectorWorkFlows } from "../../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getTypeOfServices = async ({ categoryType }) => {
  const res = await gatewaySectorWorkFlows.get(`/type-of-service?category=${categoryType}`);
  return res.data?.data || res.data;
};
